import { render, staticRenderFns } from "./TotalViewsToday.vue?vue&type=template&id=4ce7354a&scoped=true"
import script from "./TotalViewsToday.vue?vue&type=script&lang=js"
export * from "./TotalViewsToday.vue?vue&type=script&lang=js"
import style0 from "./TotalViewsToday.vue?vue&type=style&index=0&id=4ce7354a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce7354a",
  null
  
)

export default component.exports